export { default } from './about-the-brand';
